import { render } from "./ReferenceSettingsSection.vue?vue&type=template&id=630737b0"
import script from "./ReferenceSettingsSection.vue?vue&type=script&lang=js"
export * from "./ReferenceSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__